<template>
  <div>
    <StatsByZoneModal
      :id="id"
      :zone-distribution="data.config.buckets"
    />
    <b-card
      style="cursor:pointer"
      @click="displayModalTable"
    >
      <div class="d-flex justify-content-between align-items-center">
        <h3 class="text-primary mb-0">
          {{ data.label }}
        </h3>
        <b-button
          variant="flat-primary"
          class="btn-icon rounded-circle"
          @click.prevent="$emit('refetch')"
        >
          <feather-icon
            icon="RefreshCwIcon"
          />
        </b-button>
      </div>
      <h4 class="text-center mt-2">
        {{ data.doc_count }}
      </h4>
    </b-card>
  </div>
</template>

<script>
import { BCard, BButton } from 'bootstrap-vue'
import StatsByZoneModal from './StatsByZoneModal.vue'

export default {
  components: {
    BCard,
    BButton,
    StatsByZoneModal,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    serviceType: {
      type: String,
      default: undefined,
    },
  },
  setup(props, { root }) {
    const id = `${props.serviceType}-${props.data.label}-trips-stats`
    const displayModalTable = () => {
      root.$bvModal.show(id)
    }
    return {
      id,
      displayModalTable,
    }
  },
}
</script>

<style>

</style>
